// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function convertEmptyToNull<T>(obj: Record<string, any>): T {
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      // If the value is an empty string, replace it with null
      if (obj[key] === '') {
        obj[key] = null;
      }
      // If the value is an object itself, recursively call the function
      else if (typeof obj[key] === 'object' && obj[key] !== null) {
        obj[key] = convertEmptyToNull(obj[key]);
      }
    }
  }
  return obj as T;
}
